// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var DomUtils = require("../../../shared/src/DomUtils.bs.js");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var MathUtils = require("../../../shared/src/MathUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var WebTypes_View = require("../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebTypes_Shift = require("../types/WebTypes_Shift.bs.js");
var CommonTypes_Shift = require("../../../shared/src/types/CommonTypes_Shift.bs.js");
var CommonTypes_Rating = require("../../../shared/src/types/CommonTypes_Rating.bs.js");
var CommonTypes_User_Name = require("../../../shared/src/types/CommonTypes_User_Name.bs.js");
var BrowserComponents_Card = require("../../../shared-browser/src/components/BrowserComponents_Card.bs.js");
var BrowserComponents_Icon = require("../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Modal = require("../../../shared-browser/src/components/BrowserComponents_Modal.bs.js");
var CommonTypes_PhoneNumber = require("../../../shared/src/types/CommonTypes_PhoneNumber.bs.js");
var CommonTypes_WorkerShift = require("../../../shared/src/types/CommonTypes_WorkerShift.bs.js");
var BrowserComponents_Button = require("../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Rating = require("../../../shared-browser/src/components/BrowserComponents_Rating.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_Subtext = require("../../../shared-browser/src/components/BrowserComponents_Subtext.bs.js");
var CommonTypes_WorkerMessage = require("../../../shared/src/types/CommonTypes_WorkerMessage.bs.js");
var BrowserComponents_Textarea = require("../../../shared-browser/src/components/BrowserComponents_Textarea.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var CommonTypes_Shift_Accessory = require("../../../shared/src/types/CommonTypes_Shift_Accessory.bs.js");
var CommonTypes_Shift_DressCode = require("../../../shared/src/types/CommonTypes_Shift_DressCode.bs.js");
var BrowserComponents_FlexColumn = require("../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var BrowserComponents_SectionHeader = require("../../../shared-browser/src/components/BrowserComponents_SectionHeader.bs.js");
var BrowserComponents_DualColumnContent = require("../../../shared-browser/src/components/BrowserComponents_DualColumnContent.bs.js");
var CommonTypes_Business_Location_ParkingCost = require("../../../shared/src/types/business/CommonTypes_Business_Location_ParkingCost.bs.js");

var containerStyle = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, /* OpenSans */1, undefined, undefined)({
          hd: BrowserStyle.margin(BrowserStyle.rem(0.125)),
          tl: /* [] */0
        }));

function arg(param) {
  return BrowserStyle.withFont(param, /* OpenSans */1, /* XSmall */1, /* Normal */0);
}

var textStyle = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
          hd: Css.unsafe("word-break", "break-word"),
          tl: /* [] */0
        }));

var imageStyle = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.marginRight(BrowserStyle.rem(0.4375)),
      tl: {
        hd: BrowserStyle.height(BrowserStyle.rem(1.5)),
        tl: {
          hd: BrowserStyle.width(BrowserStyle.rem(1.5)),
          tl: {
            hd: BrowserStyle.minWidth(BrowserStyle.rem(1.5)),
            tl: {
              hd: BrowserStyle.borderRadius(BrowserStyle.rem(1.5)),
              tl: {
                hd: BrowserStyle.display("inlineBlock"),
                tl: {
                  hd: BrowserStyle.verticalAlign("top"),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var Styles = {
  containerStyle: containerStyle,
  textStyle: textStyle,
  imageStyle: imageStyle
};

function WebComponents_ShiftCard$InfoStrip(Props) {
  var className = Props.className;
  var iconType = Props.iconType;
  var title = Props.title;
  var emphasisOpt = Props.emphasis;
  var children = Props.children;
  var emphasis = emphasisOpt !== undefined ? emphasisOpt : /* Title */0;
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: BrowserStyle.Utils.extendBaseStyle(containerStyle, className),
              children: null
            }, Relude_Option.fold(null, (function (icon) {
                    if (icon.TAG === /* Avatar */0) {
                      return React.createElement(React.Fragment, undefined, React.createElement("img", {
                                      className: imageStyle,
                                      src: icon._0
                                    }), React.createElement(BrowserComponents_Spacer.make, {
                                      size: /* Small */3
                                    }));
                    } else {
                      return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Icon.make, {
                                      icon: {
                                        TAG: /* Small */1,
                                        _0: icon._0
                                      }
                                    }), React.createElement(BrowserComponents_Spacer.make, {
                                      size: /* Small */3
                                    }));
                    }
                  }), iconType), React.createElement(BrowserComponents_FlexColumn.make, {
                  children: null
                }, Relude_Option.fold(null, (function (title) {
                        if (emphasis) {
                          return React.createElement(BrowserComponents_Subtext.make, {
                                      children: title
                                    });
                        } else {
                          return React.createElement(BrowserComponents_Text.make, {
                                      className: textStyle,
                                      children: title
                                    });
                        }
                      }), title), emphasis ? React.createElement(BrowserComponents_Text.make, {
                        className: textStyle,
                        children: children
                      }) : React.createElement(BrowserComponents_Subtext.make, {
                        children: children
                      })));
}

var InfoStrip = {
  Styles: Styles,
  make: WebComponents_ShiftCard$InfoStrip
};

var childrenContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.alignItems(BrowserStyle.flexStart),
        tl: {
          hd: BrowserStyle.justifyContent(BrowserStyle.spaceBetween),
          tl: /* [] */0
        }
      }
    });

var Styles$1 = {
  childrenContainer: childrenContainer
};

function WebComponents_ShiftCard$OnsiteManagerSection(Props) {
  var param = Props.onsiteManager;
  var children = Props.children;
  return React.createElement(BrowserComponents_DualColumnContent.make, {
              children: null
            }, React.createElement("div", undefined, React.createElement(BrowserComponents_SectionHeader.make, {
                      children: param.name
                    }), React.createElement(BrowserComponents_Subtext.make, {
                      children: CommonTypes_LongPhoneNumber.toFormattedString(param.phoneNumber)
                    })), React.createElement("div", {
                  className: childrenContainer
                }, children));
}

var OnsiteManagerSection = {
  Styles: Styles$1,
  make: WebComponents_ShiftCard$OnsiteManagerSection
};

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.flexDirection(BrowserStyle.column),
        tl: /* [] */0
      }
    });

var header = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.marginBottom(BrowserStyle.rem(0.5)),
      tl: {
        hd: BrowserStyle.width("auto"),
        tl: {
          hd: BrowserStyle.flex({
                NAME: "num",
                VAL: 1.0
              }),
          tl: /* [] */0
        }
      }
    });

var professionalsSection = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
      tl: {
        hd: BrowserStyle.maxHeight(BrowserStyle.rem(12.0)),
        tl: {
          hd: BrowserStyle.overflowY("auto"),
          tl: /* [] */0
        }
      }
    });

var headerSection = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: /* [] */0
    });

var professional = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.pct(49.0)),
      tl: {
        hd: BrowserStyle.overflow("hidden"),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
                tl: /* [] */0
              }),
          tl: {
            hd: BrowserStyle.height(BrowserStyle.rem(2.0)),
            tl: {
              hd: BrowserStyle.margin("zero"),
              tl: /* [] */0
            }
          }
        }
      }
    });

function arg$1(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* Medium */3, /* Bold */2);
}

var rosterButton = Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined), {
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Dark */1
              }),
          tl: {
            hd: BrowserStyle.maxHeight(BrowserStyle.rem(1.0)),
            tl: {
              hd: BrowserStyle.textOverflow("ellipsis"),
              tl: {
                hd: BrowserStyle.textDecoration("underline"),
                tl: {
                  hd: BrowserStyle.overflow("hidden"),
                  tl: {
                    hd: BrowserStyle.textAlign("right"),
                    tl: {
                      hd: BrowserStyle.cursor("pointer"),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }));

var Styles$2 = {
  container: container,
  header: header,
  professionalsSection: professionalsSection,
  headerSection: headerSection,
  professional: professional,
  rosterButton: rosterButton
};

var containerStyle$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.margin(BrowserStyle.rem(0.125)),
        tl: {
          hd: BrowserStyle.alignItems("center"),
          tl: {
            hd: BrowserStyle.width(BrowserStyle.pct(49.0)),
            tl: /* [] */0
          }
        }
      }
    });

var copyStyle = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.flexDirection(BrowserStyle.column),
        tl: /* [] */0
      }
    });

function arg$2(param) {
  return BrowserStyle.withFont(param, /* OpenSans */1, /* XSmall */1, /* Normal */0);
}

var titleStyle = Curry._1(BrowserStyle.style, Curry._1(arg$2(undefined), {
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Lightest */4
              }),
          tl: /* [] */0
        }));

var circleStyle = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.padding(BrowserStyle.rem(0.125)),
      tl: {
        hd: BrowserStyle.marginRight(BrowserStyle.rem(0.4375)),
        tl: {
          hd: BrowserStyle.height(BrowserStyle.rem(1.5)),
          tl: {
            hd: BrowserStyle.width(BrowserStyle.rem(1.5)),
            tl: {
              hd: BrowserStyle.minWidth(BrowserStyle.rem(1.5)),
              tl: {
                hd: BrowserStyle.borderRadius(BrowserStyle.rem(1.5)),
                tl: {
                  hd: BrowserStyle.backgroundColor({
                        TAG: /* Grey */2,
                        _0: /* Lightest */4
                      }),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var Styles$3 = {
  containerStyle: containerStyle$1,
  copyStyle: copyStyle,
  titleStyle: titleStyle,
  circleStyle: circleStyle
};

function WebComponents_ShiftCard$ProfessionalList$FindingProfessionals(Props) {
  return React.createElement("div", {
              className: containerStyle$1
            }, React.createElement("span", {
                  className: circleStyle
                }), React.createElement("div", {
                  className: copyStyle
                }, React.createElement(BrowserComponents_Text.make, {
                      className: Curry._1(Css.merge, {
                            hd: titleStyle,
                            tl: {
                              hd: "finding-professionals",
                              tl: /* [] */0
                            }
                          }),
                      children: "Finding Professionals"
                    })));
}

var FindingProfessionals = {
  Styles: Styles$3,
  make: WebComponents_ShiftCard$ProfessionalList$FindingProfessionals
};

function WebComponents_ShiftCard$ProfessionalList(Props) {
  var param = Props.shift;
  var professionals = Props.professionals;
  var ratingMessageUniqueCode = Props.ratingMessageUniqueCode;
  var tipsPayoutType = param.tipsPayoutType;
  var originalNumberOfWorkers = param.originalNumberOfWorkers;
  return React.createElement("section", {
              className: container
            }, React.createElement("div", {
                  className: headerSection
                }, React.createElement(BrowserComponents_SectionHeader.make, {
                      className: header,
                      children: (
                        originalNumberOfWorkers !== 1 ? Relude_Int.toString(originalNumberOfWorkers) + " Professionals" : "1 Professional"
                      ) + (" - " + (MathUtils.formatCentsToMoney(param.businessRateCents) + ("/hr" + (
                              typeof tipsPayoutType === "number" && tipsPayoutType !== 0 ? " +tips" : ""
                            ))))
                    }), Relude_Option.fold(null, (function (code) {
                        return React.createElement("span", {
                                    className: rosterButton,
                                    onClick: (function (param) {
                                        return IOUtils.unsafeRunHandledAsync(DomUtils.$$Window.redirectTo("/roster/" + Curry._1(CommonTypes_WorkerMessage.UniqueCode.toString, code)));
                                      })
                                  }, React.createElement(ReactUtils.S.make, {
                                        children: "View Roster"
                                      }));
                      }), ratingMessageUniqueCode)), React.createElement("div", {
                  className: professionalsSection
                }, React.createElement(ReactUtils.A.make, {
                      children: Curry._2(Relude_Array.map, (function (param) {
                              return React.createElement(WebComponents_ShiftCard$InfoStrip, {
                                          className: professional,
                                          iconType: Relude_Option.fold({
                                                TAG: /* Icon */1,
                                                _0: {
                                                  TAG: /* Navigation */5,
                                                  _0: /* Profile */8
                                                }
                                              }, (function (param) {
                                                  return {
                                                          TAG: /* Avatar */0,
                                                          _0: param.imageUrl
                                                        };
                                                }), param.workerProfilePicture),
                                          title: CommonTypes_User_Name.toString(param.workerName),
                                          children: CommonTypes_PhoneNumber.toFormattedString(param.phoneNumber),
                                          key: "WS" + Curry._1(CommonTypes_WorkerShift.Id.toString, param.id)
                                        });
                            }), professionals)
                    }), Curry._2(Relude_Int.OrdNamed.greaterThan, Relude_Array.length(professionals), originalNumberOfWorkers) && Relude_Option.isNone(param.cancelledAt) ? React.createElement(WebComponents_ShiftCard$ProfessionalList$FindingProfessionals, {}) : React.createElement("div", undefined)));
}

var ProfessionalList = {
  Styles: Styles$2,
  FindingProfessionals: FindingProfessionals,
  make: WebComponents_ShiftCard$ProfessionalList
};

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.table),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
        tl: {
          hd: BrowserStyle.paddingRight(BrowserStyle.rem(1.0)),
          tl: /* [] */0
        }
      }
    });

var tableRow = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.tableRow),
      tl: /* [] */0
    });

var tableCol = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.tableCell),
      tl: {
        hd: BrowserStyle.width("auto"),
        tl: {
          hd: BrowserStyle.minWidth(BrowserStyle.pct(20.0)),
          tl: /* [] */0
        }
      }
    });

var tableHeaderSpacer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.marginBottom(BrowserStyle.rem(0.5)),
      tl: /* [] */0
    });

var spacer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.marginRight(BrowserStyle.rem(1.0)),
      tl: /* [] */0
    });

var Styles$4 = {
  container: container$1,
  tableRow: tableRow,
  tableCol: tableCol,
  tableHeaderSpacer: tableHeaderSpacer,
  spacer: spacer
};

function WebComponents_ShiftCard$ProfessionalRatings(Props) {
  var isEditableOpt = Props.isEditable;
  var professionalRatings = Props.professionalRatings;
  var reviewWorker = Props.reviewWorker;
  var timezone = Props.timezone;
  var isEditable = isEditableOpt !== undefined ? isEditableOpt : true;
  return React.createElement("section", {
              className: container$1
            }, React.createElement("header", {
                  className: tableRow
                }, React.createElement(BrowserComponents_SectionHeader.make, {
                      className: tableCol,
                      children: "Professional"
                    }), React.createElement(BrowserComponents_SectionHeader.make, {
                      className: tableCol,
                      children: "In"
                    }), React.createElement(BrowserComponents_SectionHeader.make, {
                      className: tableCol,
                      children: "Out"
                    }), React.createElement(BrowserComponents_SectionHeader.make, {
                      className: tableCol,
                      children: "Rating"
                    })), React.createElement("div", {
                  className: tableHeaderSpacer
                }), React.createElement(ReactUtils.A.make, {
                  children: Curry._2(Relude_Array.map, (function (workerShift) {
                          var rating = workerShift.rating;
                          return React.createElement("div", {
                                      key: Curry._1(CommonTypes_WorkerShift.Id.toString, workerShift.id),
                                      className: tableRow
                                    }, React.createElement(BrowserComponents_Subtext.make, {
                                          className: tableCol,
                                          children: CommonTypes_User_Name.toString(workerShift.workerName)
                                        }), React.createElement(BrowserComponents_Subtext.make, {
                                          className: tableCol,
                                          children: Relude_Option.fold("", DateUtils.formatDate(/* Time */14, /* Zone */{
                                                    _0: timezone
                                                  }), workerShift.clockedInAt)
                                        }), React.createElement(BrowserComponents_Subtext.make, {
                                          className: tableCol,
                                          children: Relude_Option.fold("", DateUtils.formatDate(/* Time */14, /* Zone */{
                                                    _0: timezone
                                                  }), workerShift.clockedOutAt)
                                        }), React.createElement("div", {
                                          className: tableCol
                                        }, React.createElement(BrowserComponents_Rating.make, {
                                              isEditable: Relude_Option.isNone(rating) && isEditable,
                                              onRate: Curry._1(reviewWorker, workerShift),
                                              rating: rating
                                            })));
                        }), professionalRatings)
                }));
}

var ProfessionalRatings = {
  Styles: Styles$4,
  make: WebComponents_ShiftCard$ProfessionalRatings
};

var titleText = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.overflow("hidden"),
      tl: {
        hd: BrowserStyle.textOverflow("ellipsis"),
        tl: {
          hd: BrowserStyle.width({
                NAME: "calc",
                VAL: [
                  "sub",
                  BrowserStyle.pct(100.0),
                  BrowserStyle.px(0)
                ]
              }),
          tl: /* [] */0
        }
      }
    });

var addressContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.minHeight(BrowserStyle.rem(3.0)),
      tl: /* [] */0
    });

var Styles$5 = {
  titleText: titleText,
  addressContainer: addressContainer
};

function WebComponents_ShiftCard$ShiftAddress(Props) {
  var addressName = Props.addressName;
  var address = Props.address;
  var businessName = Props.businessName;
  var className = Props.className;
  return React.createElement("div", {
              className: BrowserStyle.Utils.extendBaseStyle(addressContainer, className)
            }, React.createElement(BrowserComponents_SectionHeader.make, {
                  className: titleText,
                  children: addressName !== undefined ? addressName : businessName,
                  maxNumberOfLines: 1
                }), React.createElement(BrowserComponents_Subtext.make, {
                  children: address
                }));
}

var ShiftAddress = {
  Styles: Styles$5,
  make: WebComponents_ShiftCard$ShiftAddress
};

function container$2(isExpanded) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.display("flex"),
              tl: {
                hd: BrowserStyle.flexBasis(BrowserStyle.pct(45.0)),
                tl: {
                  hd: BrowserStyle.flexDirection("row"),
                  tl: {
                    hd: isExpanded ? BrowserStyle.maxHeight(BrowserStyle.pct(100.0)) : BrowserStyle.maxHeight(BrowserStyle.rem(8.125)),
                    tl: {
                      hd: BrowserStyle.padding(BrowserStyle.zero),
                      tl: {
                        hd: BrowserStyle.mobileMedia({
                              hd: BrowserStyle.flexBasis(BrowserStyle.pct(100.0)),
                              tl: {
                                hd: BrowserStyle.flexDirection("column"),
                                tl: {
                                  hd: isExpanded ? BrowserStyle.maxHeight(BrowserStyle.pct(100.0)) : BrowserStyle.maxHeight(BrowserStyle.rem(12.125)),
                                  tl: /* [] */0
                                }
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            });
}

var mainContent = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.padding2(BrowserStyle.Spacing.medium, BrowserStyle.Spacing.large),
        tl: /* [] */0
      }
    });

var Styles$6 = {
  container: container$2,
  mainContent: mainContent
};

var shiftId = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* White */7,
            _0: /* Light */2
          }),
      tl: {
        hd: BrowserStyle.mobileMedia({
              hd: BrowserStyle.margin(BrowserStyle.px(0)),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

function sidePanel(state) {
  var tmp;
  switch (state) {
    case /* ActiveCollapsed */0 :
        tmp = {
          TAG: /* Blue */0,
          _0: /* Darkest */0
        };
        break;
    case /* ActiveExpanded */1 :
        tmp = {
          TAG: /* Teal */6,
          _0: /* Medium */2
        };
        break;
    case /* Inactive */2 :
        tmp = {
          TAG: /* Grey */2,
          _0: /* Medium */2
        };
        break;
    
  }
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.display(BrowserStyle.flexBox),
              tl: {
                hd: BrowserStyle.flexDirection(BrowserStyle.column),
                tl: {
                  hd: BrowserStyle.alignItems(BrowserStyle.center),
                  tl: {
                    hd: BrowserStyle.flex({
                          NAME: "num",
                          VAL: 0.0
                        }),
                    tl: {
                      hd: BrowserStyle.flexBasis(BrowserStyle.rem(4.5)),
                      tl: {
                        hd: BrowserStyle.backgroundColor(tmp),
                        tl: {
                          hd: BrowserStyle.textAlign("center"),
                          tl: {
                            hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                            tl: {
                              hd: BrowserStyle.mobileMedia({
                                    hd: BrowserStyle.flexBasis(BrowserStyle.auto),
                                    tl: {
                                      hd: BrowserStyle.flexDirection("row"),
                                      tl: {
                                        hd: BrowserStyle.justifyContent("flexStart"),
                                        tl: /* [] */0
                                      }
                                    }
                                  }),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

var shiftRate = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* XSmall */1, undefined)({
          hd: BrowserStyle.color({
                TAG: /* White */7,
                _0: /* Dark */0
              }),
          tl: /* [] */0
        }));

var textContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.mobileMedia({
            hd: BrowserStyle.marginLeft("auto"),
            tl: /* [] */0
          }),
      tl: /* [] */0
    });

var Styles$7 = {
  shiftId: shiftId,
  sidePanel: sidePanel,
  shiftRate: shiftRate,
  textContainer: textContainer
};

function WebComponents_ShiftCard$SidePanel(Props) {
  var isExpanded = Props.isExpanded;
  var param = Props.shift;
  var shiftStatus = Props.shiftStatus;
  return React.createElement("div", {
              className: sidePanel(shiftStatus !== 1 ? (
                      isExpanded ? /* ActiveExpanded */1 : /* ActiveCollapsed */0
                    ) : /* Inactive */2)
            }, React.createElement(BrowserComponents_Icon.make, {
                  color: {
                    TAG: /* White */7,
                    _0: /* Light */2
                  },
                  icon: {
                    TAG: /* Large */0,
                    _0: {
                      TAG: /* ShiftTypeCategory */2,
                      _0: param.shiftType.category
                    }
                  },
                  size: /* XLarge */4
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement("div", {
                  className: textContainer
                }, React.createElement(BrowserComponents_SectionHeader.make, {
                      className: shiftId,
                      children: "#" + Curry._1(CommonTypes_Shift.Id.toString, param.id)
                    }), React.createElement(BrowserComponents_Subtext.make, {
                      className: shiftRate,
                      children: MathUtils.formatCentsToMoney(param.businessRateCents) + "/hr"
                    })));
}

var SidePanel = {
  Styles: Styles$7,
  make: WebComponents_ShiftCard$SidePanel
};

var container$3 = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* XXSmall */0, undefined)({
          hd: BrowserStyle.alignItems(BrowserStyle.center),
          tl: {
            hd: BrowserStyle.display("flex"),
            tl: {
              hd: BrowserStyle.flexDirection(BrowserStyle.column),
              tl: {
                hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
                tl: /* [] */0
              }
            }
          }
        }));

var Styles$8 = {
  container: container$3
};

function WebComponents_ShiftCard$ShiftActionButton(Props) {
  var className = Props.className;
  var icon = Props.icon;
  var onClick = Props.onClick;
  var title = Props.title;
  var testId = Props.testId;
  var tmp = {
    children: null,
    className: BrowserStyle.Utils.extendBaseStyle(container$3, className),
    onClick: (function (param) {
        return onClick;
      })
  };
  if (testId !== undefined) {
    tmp.testId = Caml_option.valFromOption(testId);
  }
  return React.createElement(BrowserComponents_Button.Base.make, tmp, React.createElement(BrowserComponents_Icon.make, {
                  icon: {
                    TAG: /* Small */1,
                    _0: icon
                  },
                  size: /* Large */3
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XSmall */2
                }), React.createElement(BrowserComponents_Text.make, {
                  children: title
                }));
}

var ShiftActionButton = {
  Styles: Styles$8,
  make: WebComponents_ShiftCard$ShiftActionButton
};

var timeRanges = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.flexDirection(BrowserStyle.column),
        tl: {
          hd: BrowserStyle.alignItems(BrowserStyle.flexEnd),
          tl: {
            hd: BrowserStyle.flex({
                  NAME: "num",
                  VAL: 1.0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var infoWithExpand = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.marginTop(BrowserStyle.rem(1.0)),
      tl: {
        hd: BrowserStyle.display(BrowserStyle.flexBox),
        tl: {
          hd: BrowserStyle.alignItems(BrowserStyle.flexStart),
          tl: {
            hd: BrowserStyle.justifyContent(BrowserStyle.spaceBetween),
            tl: {
              hd: BrowserStyle.minHeight(BrowserStyle.rem(2.625)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var flexOne = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.overflowX("hidden"),
        tl: /* [] */0
      }
    });

var infoWithExpandIconButtons = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.flexEnd),
        tl: /* [] */0
      }
    });

var alignRight = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.textAlign("right"),
      tl: /* [] */0
    });

var Styles$9 = {
  timeRanges: timeRanges,
  infoWithExpand: infoWithExpand,
  flexOne: flexOne,
  infoWithExpandIconButtons: infoWithExpandIconButtons,
  alignRight: alignRight
};

function getHourRange(startDatetime, endDatetime, timezone) {
  return DateUtils.formatDate(/* Time */14, /* Zone */{
                _0: timezone
              })(startDatetime) + (" - " + DateUtils.formatDate(/* Time */14, /* Zone */{
                  _0: timezone
                })(endDatetime));
}

function getDayRange(startDatetime, endDatetime, timezone) {
  if (DateUtils.eq(undefined, /* Day */4, startDatetime, endDatetime)) {
    return DateUtils.formatDate(/* ShortDate */7, /* Zone */{
                  _0: timezone
                })(startDatetime);
  } else {
    return DateUtils.formatDate(/* ShortDate */7, /* Zone */{
                  _0: timezone
                })(startDatetime) + (" - " + DateUtils.formatDate(/* ShortDate */7, /* Zone */{
                    _0: timezone
                  })(endDatetime));
  }
}

function WebComponents_ShiftCard$Summary(Props) {
  var isExpanded = Props.isExpanded;
  var param = Props.shift;
  var onCopy = Props.onCopy;
  var setIsExpanded = Props.setIsExpanded;
  var timezone = Props.timezone;
  var shiftStatus = Props.shiftStatus;
  var workerShifts = param.workerShifts;
  var startDatetime = param.startDatetime;
  var originalNumberOfWorkers = param.originalNumberOfWorkers;
  var match = param.location;
  var endDatetime = param.endDatetime;
  var tmp;
  if (shiftStatus !== 1) {
    var arg = new Date();
    tmp = React.createElement(BrowserComponents_Subtext.make, {
          children: DateUtils.isAfter(undefined, undefined, arg)(endDatetime) ? Relude_Int.toString(Relude_Array.length(workerShifts)) + ("/" + (Relude_Int.toString(originalNumberOfWorkers) + (
                  originalNumberOfWorkers !== 1 ? " Professionals" : " Professional"
                ))) : Relude_Int.toString(Relude_Array.length(workerShifts)) + (
              originalNumberOfWorkers !== 1 ? " Professionals" : " Professional"
            )
        });
  } else {
    tmp = React.createElement(BrowserComponents_Subtext.make, {
          children: "Cancelled - " + (Relude_Int.toString(originalNumberOfWorkers) + (
              originalNumberOfWorkers !== 1 ? " Professionals" : " Professional"
            ))
        });
  }
  var tmp$1 = {
    address: match.address,
    businessName: param.businessName
  };
  var tmp$2 = Relude_String.toNonWhitespace(match.name);
  if (tmp$2 !== undefined) {
    tmp$1.addressName = Caml_option.valFromOption(tmp$2);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_DualColumnContent.make, {
                  children: null
                }, React.createElement("div", {
                      className: flexOne
                    }, React.createElement(BrowserComponents_SectionHeader.make, {
                          children: param.shiftType.name
                        }), tmp), React.createElement("div", {
                      className: timeRanges
                    }, React.createElement(BrowserComponents_SectionHeader.make, {
                          className: alignRight,
                          children: getHourRange(startDatetime, endDatetime, timezone)
                        }), React.createElement(BrowserComponents_Subtext.make, {
                          children: getDayRange(startDatetime, endDatetime, timezone)
                        }))), React.createElement("div", {
                  className: infoWithExpand
                }, React.createElement("div", {
                      className: flexOne
                    }, React.createElement(WebComponents_ShiftCard$ShiftAddress, tmp$1)), React.createElement(BrowserComponents_FlexRow.make, {
                      children: null
                    }, React.createElement(WebComponents_ShiftCard$ShiftActionButton, {
                          icon: {
                            TAG: /* Shift */6,
                            _0: /* Copy */9
                          },
                          onClick: Curry._1(onCopy, param.id),
                          title: "Copy Shift"
                        }), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Medium */4
                        }), React.createElement(WebComponents_ShiftCard$ShiftActionButton, {
                          icon: {
                            TAG: /* Navigation */5,
                            _0: isExpanded ? /* Minus */4 : /* Plus */7
                          },
                          onClick: Curry._1(setIsExpanded, Relude_Globals.inverse(isExpanded)),
                          title: isExpanded ? "Summary" : "Details",
                          testId: "detailsButton"
                        }))));
}

var Summary = {
  Styles: Styles$9,
  getHourRange: getHourRange,
  getDayRange: getDayRange,
  make: WebComponents_ShiftCard$Summary
};

var base = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* Grey */2,
            _0: /* Light */3
          }),
      tl: {
        hd: BrowserStyle.borderWidth(BrowserStyle.rem(0.0)),
        tl: {
          hd: BrowserStyle.height(BrowserStyle.px(1)),
          tl: {
            hd: BrowserStyle.marginTop(BrowserStyle.rem(1.0)),
            tl: {
              hd: BrowserStyle.marginBottom(BrowserStyle.rem(1.0)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles$10 = {
  base: base
};

function WebComponents_ShiftCard$Details$Seperator(Props) {
  return React.createElement("hr", {
              className: base
            });
}

var Seperator = {
  Styles: Styles$10,
  make: WebComponents_ShiftCard$Details$Seperator
};

var attireLeftMargin = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.marginLeft(BrowserStyle.rem(1.875)),
      tl: /* [] */0
    });

var modalButton = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: /* [] */0
    });

var Styles$11 = {
  attireLeftMargin: attireLeftMargin,
  modalButton: modalButton
};

function WebComponents_ShiftCard$Details$UpcomingShift(Props) {
  var currentDatetime = Props.currentDatetime;
  var shift = Props.shift;
  var onCancel = Props.onCancel;
  var professionals = Props.professionals;
  var setView = Props.setView;
  var $staropt$star = Props.shiftStatus;
  var dressCode = shift.dressCode;
  var attire = shift.attire;
  var accessories = shift.accessories;
  var shiftStatus = $staropt$star !== undefined ? $staropt$star : /* Active */0;
  var match = ReactIO.useState(function (param) {
        return false;
      });
  var setModalShowing = match[1];
  return React.createElement("div", undefined, React.createElement(WebComponents_ShiftCard$Details$Seperator, {}), React.createElement(WebComponents_ShiftCard$OnsiteManagerSection, {
                  onsiteManager: shift.onsiteManager,
                  children: shiftStatus !== 1 ? React.createElement(React.Fragment, undefined, WebTypes_Shift.canBusinessCancelShift(currentDatetime, shift) ? React.createElement(WebComponents_ShiftCard$ShiftActionButton, {
                                icon: {
                                  TAG: /* Status */8,
                                  _0: /* CircleX */11
                                },
                                onClick: Curry._1(setModalShowing, true),
                                title: "Cancel Shift",
                                testId: "cancelButton"
                              }) : null, WebTypes_Shift.canBusinessEditShift(currentDatetime, shift) ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Medium */4
                                  }), React.createElement(WebComponents_ShiftCard$ShiftActionButton, {
                                    icon: {
                                      TAG: /* Shift */6,
                                      _0: /* PencilEdit */16
                                    },
                                    onClick: Curry._1(setView, WebTypes_View.editShift(shift.id)),
                                    title: "Edit Shift",
                                    testId: "editButton"
                                  })) : null) : null
                }), React.createElement(WebComponents_ShiftCard$Details$Seperator, {}), React.createElement(WebComponents_ShiftCard$ProfessionalList, {
                  shift: shift,
                  professionals: professionals,
                  ratingMessageUniqueCode: shiftStatus !== 1 ? Caml_option.some(shift.ratingMessageUniqueCode) : undefined
                }), React.createElement(WebComponents_ShiftCard$Details$Seperator, {}), React.createElement(BrowserComponents_FlexColumn.make, {
                  children: null
                }, React.createElement(BrowserComponents_SectionHeader.make, {
                      children: "Description"
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Small */3
                    }), React.createElement(BrowserComponents_Subtext.make, {
                      children: shift.description
                    })), React.createElement(WebComponents_ShiftCard$Details$Seperator, {}), React.createElement(BrowserComponents_FlexColumn.make, {
                  children: null
                }, React.createElement(BrowserComponents_SectionHeader.make, {
                      children: "Location"
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Small */3
                    }), React.createElement(WebComponents_ShiftCard$InfoStrip, {
                      iconType: {
                        TAG: /* Icon */1,
                        _0: {
                          TAG: /* Shift */6,
                          _0: /* Location */13
                        }
                      },
                      title: "Address",
                      emphasis: /* Body */1,
                      children: shift.location.address
                    }), React.createElement(WebComponents_ShiftCard$InfoStrip, {
                      iconType: {
                        TAG: /* Icon */1,
                        _0: {
                          TAG: /* Shift */6,
                          _0: /* Car */5
                        }
                      },
                      title: "Parking Cost",
                      emphasis: /* Body */1,
                      children: CommonTypes_Business_Location_ParkingCost.toDisplayString(shift.parkingCost)
                    }), React.createElement(WebComponents_ShiftCard$InfoStrip, {
                      iconType: {
                        TAG: /* Icon */1,
                        _0: {
                          TAG: /* Shift */6,
                          _0: /* Clipboard */8
                        }
                      },
                      title: "Arrival Instructions",
                      emphasis: /* Body */1,
                      children: shift.parkingInstructions
                    })), React.createElement(WebComponents_ShiftCard$Details$Seperator, {}), React.createElement(BrowserComponents_FlexColumn.make, {
                  children: null
                }, React.createElement(BrowserComponents_SectionHeader.make, {
                      children: "Attire"
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Small */3
                    }), React.createElement(WebComponents_ShiftCard$InfoStrip, {
                      iconType: {
                        TAG: /* Icon */1,
                        _0: {
                          TAG: /* Shift */6,
                          _0: /* Shirt */19
                        }
                      },
                      title: CommonTypes_Shift_DressCode.toString(dressCode),
                      emphasis: /* Body */1,
                      children: Relude_Option.getOrElse("", CommonTypes_Shift_DressCode.getDescription(dressCode))
                    }), Relude_String.isEmpty(attire) ? null : React.createElement(WebComponents_ShiftCard$InfoStrip, {
                        className: attireLeftMargin,
                        title: "Special Attire Notes",
                        emphasis: /* Body */1,
                        children: attire
                      }), Curry._1(CommonTypes_Shift_Accessory.$$Set.isEmpty, accessories) ? null : React.createElement(WebComponents_ShiftCard$InfoStrip, {
                        className: attireLeftMargin,
                        title: "Accessories",
                        emphasis: /* Body */1,
                        children: Curry._3(Relude_Array.foldLeft, (function (prim, prim$1) {
                                return prim + prim$1;
                              }), "", Relude_Array.intersperse(", ", Curry._2(Relude_Array.map, CommonTypes_Shift_Accessory.toString, Curry._1(CommonTypes_Shift_Accessory.$$Set.toArray, accessories))))
                      })), match[0] ? React.createElement(BrowserComponents_Modal.Legacy.make, {
                    children: null
                  }, Curry._2(Relude_Int.greaterThan, 24, Relude_Float.toInt(DateUtils.hoursBetween(shift.startDatetime, new Date()))) ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Modal.Legacy.TitleText.make, {
                              title: "Day Prior Cancel Shift"
                            }), React.createElement(BrowserComponents_Modal.Legacy.$$Text.make, {
                              text: "Canceling this shift will result in a late cancellation fee (4 hours of compensation at the shift hourly rate per Professional) as this shift occurs within the next 24 hours. Are you sure you want to cancel? If so, click 'Cancel Shift' to cancel the shift and incur the cancellation fee.\nText us at 79425 or email us at support@qwick.com if you have any questions about our cancellation policy."
                            })) : React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Modal.Legacy.TitleText.make, {
                              title: "Cancel Shift"
                            }), React.createElement(BrowserComponents_Modal.Legacy.$$Text.make, {
                              text: "Are you sure you want to cancel this shift? If you need help or have any questions about editing a shift, please text 79425 or email us at support@qwick.com"
                            })), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* Large */5
                      }), React.createElement(BrowserComponents_Button.make, {
                        actionPriority: /* Primary */0,
                        onClick: (function (param) {
                            return Relude_IO.flatMap((function (param) {
                                          return onCancel;
                                        }), Curry._1(setModalShowing, false));
                          }),
                        testId: "cancelShiftButton",
                        title: "Cancel Shift"
                      }), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* Small */3
                      }), React.createElement(BrowserComponents_Button.make, {
                        actionPriority: /* LegacySecondary */2,
                        onClick: (function (param) {
                            return Curry._1(setModalShowing, false);
                          }),
                        title: "Nevermind, I Need to Fill This Shift"
                      })) : null);
}

var UpcomingShift = {
  Styles: Styles$11,
  make: WebComponents_ShiftCard$Details$UpcomingShift
};

var discardModal = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.zIndex(11),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.vw(30.0)),
        tl: /* [] */0
      }
    });

var discardModalOverlay = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.zIndex(10),
      tl: /* [] */0
    });

var successModal = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.textAlign("center"),
      tl: /* [] */0
    });

var successModalHeader = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display("flex"),
      tl: {
        hd: BrowserStyle.alignItems("center"),
        tl: {
          hd: BrowserStyle.flexDirection("column"),
          tl: /* [] */0
        }
      }
    });

var successText = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* XLarge */5, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Teal */6,
                _0: /* Medium */2
              }),
          tl: {
            hd: BrowserStyle.margin("zero"),
            tl: /* [] */0
          }
        }));

var modalTextArea = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(7.0)),
      tl: {
        hd: BrowserStyle.resize(BrowserStyle.none),
        tl: /* [] */0
      }
    });

var modalEqualWidthButton = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.flexBasis(BrowserStyle.zero),
        tl: /* [] */0
      }
    });

var Styles$12 = {
  discardModal: discardModal,
  discardModalOverlay: discardModalOverlay,
  successModal: successModal,
  successModalHeader: successModalHeader,
  successText: successText,
  modalTextArea: modalTextArea,
  modalEqualWidthButton: modalEqualWidthButton
};

function WebComponents_ShiftCard$Details$PastShift(Props) {
  var param = Props.shift;
  var onComment = Props.onComment;
  var onReviewWorker = Props.onReviewWorker;
  var professionalRatings = Props.professionalRatings;
  var timezone = Props.timezone;
  var $staropt$star = Props.shiftStatus;
  var shiftStatus = $staropt$star !== undefined ? $staropt$star : /* Active */0;
  var originalComment = Relude_Option.getOrElse("", param.comment);
  var match = ReactIO.useState(function (param) {
        return originalComment;
      });
  var setShiftComment = match[1];
  var shiftComment = match[0];
  var match$1 = ReactIO.useState(function (param) {
        return /* Hidden */3;
      });
  var setVisibleModal = match$1[1];
  var originalCommentIsEmpty = Relude_String.isEmpty(originalComment);
  var toggleModals = function (saveRating) {
    if (typeof saveRating === "number") {
      switch (saveRating) {
        case /* Comment */0 :
            return React.createElement(BrowserComponents_Modal.Legacy.make, {
                        children: null
                      }, React.createElement(BrowserComponents_Modal.Legacy.TitleText.make, {
                            title: "Overall Comments"
                          }), React.createElement(BrowserComponents_Modal.Legacy.$$Text.make, {
                            text: "Thanks for using Qwick, we're glad you had a great experience! We'd love to hear more about what went well, so we can continue to exceed expectations."
                          }), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Large */5
                          }), React.createElement(BrowserComponents_Textarea.make, {
                            inputClassName: modalTextArea,
                            onChange: setShiftComment,
                            placeholder: "Tell us about your experience...",
                            value: shiftComment
                          }), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Large */5
                          }), React.createElement(BrowserComponents_FlexRow.make, {
                            children: null
                          }, React.createElement(BrowserComponents_Button.make, {
                                actionPriority: /* LegacySecondary */2,
                                className: modalEqualWidthButton,
                                onClick: (function (param) {
                                    if (Relude_String.eq(shiftComment, originalComment)) {
                                      return Curry._1(setVisibleModal, /* Hidden */3);
                                    } else {
                                      return Curry._1(setVisibleModal, /* DiscardComment */1);
                                    }
                                  }),
                                title: "I'll Comment Later"
                              }), React.createElement(BrowserComponents_Spacer.make, {
                                size: /* Small */3
                              }), React.createElement(BrowserComponents_Button.make, {
                                actionPriority: /* Primary */0,
                                className: modalEqualWidthButton,
                                onClick: (function (param) {
                                    return Relude_IO.flatMap((function (param) {
                                                  return Curry._1(setVisibleModal, /* CommentSuccess */2);
                                                }), Curry._1(onComment, shiftComment));
                                  }),
                                title: originalCommentIsEmpty ? "Submit My Comment" : "Update My Comment"
                              })));
        case /* DiscardComment */1 :
            return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Modal.Legacy.make, {
                            children: null,
                            className: discardModal,
                            overlayClassName: discardModalOverlay
                          }, React.createElement(BrowserComponents_Modal.Legacy.TitleText.make, {
                                title: "Discard Comment"
                              }), React.createElement(BrowserComponents_Modal.Legacy.$$Text.make, {
                                text: "You haven't finished your comment yet. Are you sure you want to leave before finishing?"
                              }), React.createElement(BrowserComponents_Spacer.make, {
                                size: /* Large */5
                              }), React.createElement(BrowserComponents_FlexRow.make, {
                                children: null
                              }, React.createElement(BrowserComponents_Button.make, {
                                    actionPriority: /* LegacySecondary */2,
                                    className: modalEqualWidthButton,
                                    onClick: (function (param) {
                                        return Curry._1(setVisibleModal, /* Comment */0);
                                      }),
                                    title: "Go Back"
                                  }), React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Small */3
                                  }), React.createElement(BrowserComponents_Button.make, {
                                    actionPriority: /* Primary */0,
                                    className: modalEqualWidthButton,
                                    onClick: (function (param) {
                                        return Relude_IO.flatMap((function (param) {
                                                      return Curry._1(setShiftComment, originalComment);
                                                    }), Curry._1(setVisibleModal, /* Hidden */3));
                                      }),
                                    title: "Discard"
                                  }))));
        case /* CommentSuccess */2 :
            return React.createElement(BrowserComponents_Modal.Legacy.make, {
                        children: null,
                        className: successModal
                      }, React.createElement("div", {
                            className: successModalHeader
                          }, React.createElement(BrowserComponents_Icon.make, {
                                icon: {
                                  TAG: /* Small */1,
                                  _0: {
                                    TAG: /* Status */8,
                                    _0: /* Verified */14
                                  }
                                },
                                size: /* XLarge */4
                              }), React.createElement("h3", {
                                className: successText
                              }, React.createElement(ReactUtils.S.make, {
                                    children: "Success"
                                  }))), React.createElement(BrowserComponents_Modal.Legacy.$$Text.make, {
                            text: "We look forward to reviewing your feedback."
                          }), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Large */5
                          }), React.createElement(BrowserComponents_Button.make, {
                            actionPriority: /* Primary */0,
                            onClick: (function (param) {
                                return Curry._1(setVisibleModal, /* Hidden */3);
                              }),
                            title: "Continue"
                          }));
        case /* Hidden */3 :
            return null;
        
      }
    } else {
      var saveRating$1 = saveRating._0;
      return React.createElement(BrowserComponents_Modal.Legacy.make, {
                  children: null
                }, React.createElement(BrowserComponents_Modal.Legacy.TitleText.make, {
                      title: "3 Star & Below"
                    }), React.createElement(BrowserComponents_Modal.Legacy.$$Text.make, {
                      text: "A 3-star rating and below lets us know that your expectations weren't met, and we take that seriously. Please let us know in the comments section on how the experience can be improved for next time."
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement(BrowserComponents_Textarea.make, {
                      inputClassName: modalTextArea,
                      onChange: setShiftComment,
                      placeholder: "Tell us about your experience...",
                      value: shiftComment
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement(BrowserComponents_Button.make, {
                      actionPriority: /* Primary */0,
                      onClick: (function (param) {
                          return Relude_IO.flatMap((function (param) {
                                        return Curry._1(setVisibleModal, /* CommentSuccess */2);
                                      }), Curry._2(IOUtils.IOWithUnitError.mapTuple2, (function (param, param$1) {
                                            
                                          }), [
                                          Curry._1(onComment, shiftComment),
                                          saveRating$1
                                        ]));
                        }),
                      title: originalCommentIsEmpty ? "Submit My Comment" : "Update My Comment"
                    }));
    }
  };
  return React.createElement("div", undefined, React.createElement(WebComponents_ShiftCard$Details$Seperator, {}), React.createElement(WebComponents_ShiftCard$OnsiteManagerSection, {
                  onsiteManager: param.onsiteManager,
                  children: shiftStatus !== 0 ? null : React.createElement(WebComponents_ShiftCard$ShiftActionButton, {
                          icon: {
                            TAG: /* Messaging */3,
                            _0: /* Comment */1
                          },
                          onClick: Curry._1(setVisibleModal, /* Comment */0),
                          title: "Comment"
                        })
                }), React.createElement(WebComponents_ShiftCard$Details$Seperator, {}), React.createElement(WebComponents_ShiftCard$ProfessionalRatings, {
                  isEditable: shiftStatus === 0,
                  professionalRatings: professionalRatings,
                  reviewWorker: (function (id, rating) {
                      if (Curry._2(CommonTypes_Rating.OrdNamed.lessThanOrEq, /* ThreeStars */2, rating)) {
                        return Curry._1(setVisibleModal, /* LowRating */{
                                    _0: Curry._2(onReviewWorker, id, rating)
                                  });
                      } else {
                        return Curry._2(onReviewWorker, id, rating);
                      }
                    }),
                  timezone: timezone
                }), toggleModals(match$1[0]));
}

var PastShift = {
  Styles: Styles$12,
  make: WebComponents_ShiftCard$Details$PastShift
};

var Details = {
  Seperator: Seperator,
  UpcomingShift: UpcomingShift,
  PastShift: PastShift
};

function WebComponents_ShiftCard$Stateless(Props) {
  var children = Props.children;
  var isExpanded = Props.isExpanded;
  var onCopy = Props.onCopy;
  var setIsExpanded = Props.setIsExpanded;
  var shift = Props.shift;
  var shiftStatus = Props.shiftStatus;
  var timezone = Props.timezone;
  return React.createElement(BrowserComponents_Card.make, {
              className: container$2(isExpanded),
              children: null
            }, React.createElement(WebComponents_ShiftCard$SidePanel, {
                  isExpanded: isExpanded,
                  shift: shift,
                  shiftStatus: shiftStatus
                }), React.createElement("div", {
                  className: mainContent
                }, React.createElement(WebComponents_ShiftCard$Summary, {
                      isExpanded: isExpanded,
                      shift: shift,
                      onCopy: onCopy,
                      setIsExpanded: setIsExpanded,
                      timezone: timezone,
                      shiftStatus: shiftStatus
                    }), React.createElement("div", undefined, children)));
}

var Stateless = {
  make: WebComponents_ShiftCard$Stateless
};

function WebComponents_ShiftCard(Props) {
  var children = Props.children;
  var isExpandedOpt = Props.isExpanded;
  var onCopy = Props.onCopy;
  var shift = Props.shift;
  var shiftStatusOpt = Props.shiftStatus;
  var timezone = Props.timezone;
  var isExpanded = isExpandedOpt !== undefined ? isExpandedOpt : false;
  var shiftStatus = shiftStatusOpt !== undefined ? shiftStatusOpt : /* Active */0;
  var match = ReactIO.useState(function (param) {
        return isExpanded;
      });
  return React.createElement(WebComponents_ShiftCard$Stateless, {
              children: children,
              isExpanded: match[0],
              onCopy: onCopy,
              setIsExpanded: match[1],
              shift: shift,
              shiftStatus: shiftStatus,
              timezone: timezone
            });
}

var make = WebComponents_ShiftCard;

exports.InfoStrip = InfoStrip;
exports.OnsiteManagerSection = OnsiteManagerSection;
exports.ProfessionalList = ProfessionalList;
exports.ProfessionalRatings = ProfessionalRatings;
exports.ShiftAddress = ShiftAddress;
exports.Styles = Styles$6;
exports.SidePanel = SidePanel;
exports.ShiftActionButton = ShiftActionButton;
exports.Summary = Summary;
exports.Details = Details;
exports.Stateless = Stateless;
exports.make = make;
/* containerStyle Not a pure module */
